import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';
import { Modal, Button, Icon } from 'nallian-shared-ui/lib/components';
import { formatDate, formatDateTime } from 'nallian-shared-ui/lib/lib/dateTime';
import { useTranslation } from 'react-i18next';
import { DocumentStatus } from 'nallian-shared-ui/lib/layout/documents';
import DocumentPreviewModal from './DocumentPreviewModal';

const DocumentHistoryModal = ({ item, principalId, canPreview = false, onClose }) => {
  const { t } = useTranslation(['app', 'shared']);
  const [previewItem, setPreviewItem] = useState(null);

  const handlePreviewClose = useCallback(() => setPreviewItem(null), []);

  return (
    <Modal open onClose={onClose} size="large">
      <Modal.Header>{t('documents.history')}</Modal.Header>
      <Modal.Content>
        <Table celled>
          <Table.Header>
            <Table.Row>
              {canPreview && <Table.HeaderCell />}
              <Table.HeaderCell>{t('documents.fileName')}</Table.HeaderCell>
              <Table.HeaderCell>{t('documents.type')}</Table.HeaderCell>
              <Table.HeaderCell>{t('documents.uploadedBy')}</Table.HeaderCell>
              <Table.HeaderCell>{t('documents.uploadedAt')}</Table.HeaderCell>
              <Table.HeaderCell>{t('documents.status')}</Table.HeaderCell>
              <Table.HeaderCell>{t('documents.expirationDate')}</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {item.history?.map(h => (
              <Table.Row key={h.id}>
                {canPreview && (
                  <Table.Cell textAlign="center">
                    <Icon iconbutton name="eye" onClick={() => setPreviewItem(h)} />
                  </Table.Cell>
                )}
                <Table.Cell>{h.fileName}</Table.Cell>
                <Table.Cell>{t(`documents.type_${h.documentType}`, h.documentType)}</Table.Cell>
                <Table.Cell>{h.uploadedBy?.fullName || '-'}</Table.Cell>
                <Table.Cell>{h.createdOn ? formatDateTime(new Date(h.createdOn)) : '-'}</Table.Cell>
                <Table.Cell>
                  <DocumentStatus value={h.status} />
                </Table.Cell>
                <Table.Cell>{h.expiresAt ? formatDate(new Date(h.expiresAt)) : '-'}</Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </Modal.Content>
      <Modal.Actions>
        <Button content={t('close')} onClick={onClose} />
      </Modal.Actions>
      {previewItem && (
        <DocumentPreviewModal
          item={previewItem}
          principalId={principalId}
          onClose={handlePreviewClose}
        />
      )}
    </Modal>
  );
};

DocumentHistoryModal.propTypes = {
  item: PropTypes.object.isRequired,
  principalId: PropTypes.string.isRequired,
  canPreview: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

export default DocumentHistoryModal;
